import card1 from "../../assets/img/creditcard/card1.png";
import card2 from "../../assets/img/creditcard/card2.png";

const creditCardData = [
  {
    id: 1,
    name: "American Express Gold",
    apr: "21-29%",
    annualFee: "$325",
    creditScore: "690+",
    reward: "4X Membership Rewards® points at restaurants",
    limit: "$5,000-$250,000",
    averageLimit: "$20,000",
    image: card1,
  },
  {
    id: 2,
    name: "American Express Platinum",
    apr: "21-29%",
    annualFee: "$695",
    creditScore: "720+",
    reward:
      "Earn 100,000 points after spending $8,000 within the first six months.",
    limit: "$5,000-$250,000",
    averageLimit: "$15,000",
    image: card2,
  },
];

export default creditCardData;
